import { BaseModel } from '../base.model'
import { ExamSection } from './exam-section.model'
import { ExamSectionsGrade } from './exam-sections-grade.model'
import { ExamQuestionsGrade } from './exam-questions-grade.model'
import { Program } from '../program.model'

export class Exam extends BaseModel<Exam> {
  static DEFAULT_ATTRIBUTES = {
    sections: [],
    sectionsGrades: [new ExamSectionsGrade({ minSections: 0 })],
    questionsGrades: [new ExamQuestionsGrade({ minQuestions: 0 })],
    onlySectionsGrade: false,
    onlyQuestionsGrade: false,
    timeLimit: 0,
    allQuestionsSize: 0
  }

  id: number
  name: string
  state: string
  comment: string
  folderId: number
  sections: ExamSection[]
  timeLimit: number
  onlySectionsGrade: boolean
  onlyQuestionsGrade: boolean
  programs: Program[]
  sectionsGrades: ExamSectionsGrade[]
  questionsGrades: ExamQuestionsGrade[]
  allQuestionsSize: number

  removed(): boolean {
    return this.state == 'removed'
  }

  disabled(): boolean {
    return this.state == 'disabled'
  }
}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/angular-router-loader/src!./app/models/exams/exam.model.ts